import { render, staticRenderFns } from "./VesselLiveStatus.vue?vue&type=template&id=ef10405c&"
import script from "./VesselLiveStatus.vue?vue&type=script&lang=js&"
export * from "./VesselLiveStatus.vue?vue&type=script&lang=js&"
import style0 from "./VesselLiveStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports